import { noop } from 'lodash'
import gsap from 'gsap'
import { TextPlugin } from 'gsap/TextPlugin'
gsap.registerPlugin(TextPlugin)

const duration = .3

export const applyStyle = ({
  element,
  style,
  isImage,
  scrollBehaviorY
}) => {
  if (!isImage) {
    element.classList.remove(...element.classList)
  }
  element.classList.remove(
    `rounded-0`
  )

  gsap.set(element, {
    ...style.value,
    y: style.value.y + scrollBehaviorY
  })
  if (!isImage) {
    Array.from(element.children)
    .forEach((child, index) => {
      applyStyle({
        element: child,
        style: style.children[index]
      })
    })
  }
}

export const hide = ({ element }) => {
  element.classList.add(`notransition`)
  element.style.opacity = 0
  element.offsetHeight
  element.classList.remove(`notransition`)
}

export const show = ({ element }) => {
  element.classList.add(`notransition`)
  element.style.opacity = 1
  element.offsetHeight
  element.classList.remove(`notransition`)
}

export const Timeline = () => {
  let resolve = noop
  const onComplete = () => {
    resolve()
  }
  const timeline = gsap.timeline({
    paused: true,
    onReverseComplete: onComplete,
    onComplete,
    defaults: {
      duration
    }
  })
  const add = ({
    element,
    style,
    isImage,
    scrollBehaviorY
  }) => {
    const add = ({ element, style }) => {
      if (!style) {
        // fix me
        return
      }
      timeline.to(
        element, {
          ...style.value,
          y: style.value.y + scrollBehaviorY
        },
        0
      )
      if (!isImage) {
        Array.from(element.children)
        .forEach((child, index) => {
          add({
            element: child,
            style: style.children[index]
          })
        })
      }
    }
    add({ element, style })
  }

  const process = () =>
    new Promise(_resolve => {
      resolve = _resolve
      if (timeline.isActive()) {
        timeline.reverse()
      } else {
        timeline.play()
      }
    })

  return {
    add,
    process
  }
}
